<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width: 100%;">
            <el-tab-pane key="closeAccount" name="closeAccount" :label="$t('CargoMsg.Cargo_ClosingAccountRecord')" :lazy="true">
              <close-account />
            </el-tab-pane>
            <el-tab-pane key="closeAccountVerify" v-permission="['button_MTCloseAccount_accountVerify']" name="closeAccountVerify" :label="$t('CargoMsg.Cargo_ClosingAccountReview')" :lazy="true">
              <close-account-verify />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import closeAccount from '@/views/cargo/v0/Clearing/components/mtCloseAccount/closeAccount'
import closeAccountVerify from '@/views/cargo/v0/Clearing/components/mtCloseAccount/closeAccountVerify'

export default {
  name: 'MTCloseAccount',
  components: { closeAccount, closeAccountVerify },
  data() {
    return {
      activeTabName: 'closeAccount'
    }
  }
}
</script>
